export interface CapitalUse {
  index: string
  area: string
  tags: string
  outcome: string
}

export const capitalUses: CapitalUse[] = [
  {
    index: '01',
    area: 'U.S. launch & growth',
    tags: 'Performance marketing · Influencers · Affiliates · PR',
    outcome: 'Acquire and scale paid VEXU App subscribers.',
  },
  {
    index: '02',
    area: 'Product & AI',
    tags: 'AI/ML · Voice · Mobile · Platform',
    outcome: 'Advance VEXU\'s AI technology and product experience.',
  },
  {
    index: '03',
    area: 'VEXU Business',
    tags: 'Sales · Integrations · Workflows · Channels',
    outcome: 'Commercialize and scale the higher-value business platform.',
  },
  {
    index: '04',
    area: 'Infrastructure & scale',
    tags: 'GPU infrastructure · Telecom · Reliability · Security',
    outcome: 'Support growing call volumes and geographic expansion.',
  },
]

export const investmentPathway = [
  '$1.5M SAFE',
  'U.S. launch',
  'Scale VEXU App',
  'Expand VEXU Business',
  'Year-3 Base Case',
]

export const yearThreeProof = [
  { value: '$10.77M', label: 'Year-3 revenue' },
  { value: '~88%', label: 'Gross margin by Year 3' },
  { value: '18,577', label: 'Paid app subscribers' },
  { value: '1,441', label: 'Active business customers' },
]

export const profitabilityMilestone = 'Operating CF positive · Month 17'

export const upsideCallout = {
  title: 'Strategic upside — not included in 3-year projections',
  detail: 'Talab · Telecom partnership distribution · Additional verticals',
}

export const raiseClosing = 'Fund the core. Scale the platform. Preserve the upside.'
